import { DecimalPipe } from '@angular/common';
import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ENUM_NGAY_NGHI } from 'tnx-admin-service/holiday/models';
import { HolidayService } from 'tnx-admin-service/holiday/services';
import { ColumnSchemaBase, ComponentContextService, CrudListComponent, DataListBase, DataType, GridInfo, ModelSchema, Operator, RadioButtonListControlSchema } from 'tnx-shared';

@Component({
    selector: 'holiday',
    templateUrl: './holiday.component.html',
    styleUrls: ['./holiday.component.scss'],
    providers: [ComponentContextService]

})
export class HolidayComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    arrHolidayType = [];
    constructor(
        protected _injector: Injector,
        protected _hodidayService: HolidayService,
        private _decimalPipe: DecimalPipe
    ) {
        super(_injector);
    }
    ngOnInit() {
        this.setting.objectName = 'ngày nghỉ lễ';
        this.setting.baseService = this._hodidayService;
        this.arrHolidayType.push(
            { value: ENUM_NGAY_NGHI.NGAY_NGHI_LE, label: 'Ngày nghỉ lễ' },
            { value: ENUM_NGAY_NGHI.NGAY_LAM_BU, label: 'Ngày làm bù' });
        this.modelSchema = [
            new ModelSchema({ field: 'sort', name: 'Sắp xếp', fullName: 'Sắp xếp', description: '' }),
            new ModelSchema({ field: 'code', name: 'Mã', fullName: 'Mã', description: '' }),
            new ModelSchema({ field: 'name', name: 'Tên', fullName: 'Tên', description: '' }),
            new ModelSchema({ field: 'startDate', dataType: 'date', name: 'Ngày bắt đầu', fullName: 'Ngày bắt đầu', description: '' }),
            new ModelSchema({ field: 'endDate', dataType: 'date', name: 'Ngày kết thúc', fullName: 'Ngày kết thúc', description: '' }),
            new ModelSchema({ field: 'description', name: 'Mô tả', fullName: 'Mô tả', description: '' }),
            new ModelSchema({ field: 'used', name: 'Sử dụng', fullName: 'Sử dụng', description: '' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({
                field: 'code',
                label: this._translateService.instant('Mã'),
                fullTextSearch: true
            }),
            new ColumnSchemaBase({
                field: 'name',
                label: this._translateService.instant('Tên'),
                fullTextSearch: true
            }),
            new ColumnSchemaBase({
                field: 'startDate',
                dataType: DataType.date,
                label: this._translateService.instant('Từ ngày')
            }),
            new ColumnSchemaBase({
                field: 'endDate',
                label: this._translateService.instant('Đến ngày'),
                dataType: DataType.date
            }),
            new ColumnSchemaBase({
                field: 'sort',
                label: this._translateService.instant('Thứ tự')
            }),
            new ColumnSchemaBase({
                field: 'description',
                label: this._translateService.instant('Mô tả')
            })
        ];

        this.searchSchema.type = new RadioButtonListControlSchema({
            dataSource: this.arrHolidayType
        });

        this.searchData.type = ENUM_NGAY_NGHI.NGAY_NGHI_LE;
        super.ngOnInit();
    }


    onSelect(value) {
        if (this.searchData.type == ENUM_NGAY_NGHI.NGAY_NGHI_LE) {
            this.setting.objectName = 'ngày nghỉ lễ';
            this._triggerProcessData();
        }
        else if (this.searchData.type == ENUM_NGAY_NGHI.NGAY_LAM_BU) {
            this.setting.objectName = 'ngày làm bù';
            this._triggerProcessData();
        }
    }
    
    async modifyGridInfo(gridInfo: GridInfo) {
        gridInfo.sorts.splice(0, 0,
            { field: 'sort', dir: 1 }
        );
        gridInfo.filters.splice(0, 0,
            { field: 'type', operator: Operator.equal, value: this.searchData.type }
        );
    }
}
